import moment from 'moment';
import { isArray, isEmpty, isUndefined, isFunction, isString, isBoolean, first } from 'lodash';
// Import Types
import type { FilterChip } from 'types';
// Import Constants
import { FilterHolderFields } from 'constants/common';

const { textInput, select, multiSelect, rangeDate, singleDate, multiSelectAutocomplete, autocompleteOptionList } =
    FilterHolderFields;

const dateFormat = (value, formatType) => {
    return isFunction(value?.format)
        ? value.format(formatType)
        : isString(value)
          ? moment.utc(value).format(formatType)
          : value;
};

export const mapToTagListModel = (filters: AnyObject[] = [], partnerDateFormat): FilterChip[] => {
    return filters
        .filter(({ value, type }) => {
            return (type === rangeDate.type || type === singleDate.type) && isArray(value)
                ? !isEmpty(value?.filter((item) => item !== null))
                : !isEmpty(value) || isBoolean(value);
        })
        .map(({ displayName, value, data, type, valueFieldKey }: AnyObject) => {
            const result: FilterChip = {
                label: displayName,
                valueFieldKey,
                originalValue: value,
                value: undefined,
            };

            switch (type) {
                case textInput.type:
                    result.value = value;
                    break;
                case select.type:
                    result.value = first<AnyObject>(data.filter((dataItem) => value === dataItem.value))?.label;
                    break;
                case multiSelect.type:
                    // TODO: concat symbol bugs
                    result.value = value.map(
                        (valueItem) =>
                            first<AnyObject>(data.filter((dataItem) => dataItem?.value === valueItem))?.label,
                    );
                    break;
                case rangeDate.type:
                    result.value = `${dateFormat(value[0], partnerDateFormat)}  - ${dateFormat(
                        value[1],
                        partnerDateFormat,
                    )}`;
                    break;
                case singleDate.type:
                    result.value = moment(value[0]).format(partnerDateFormat);
                    break;
                case multiSelectAutocomplete.type:
                    result.value = value.map(
                        (valueItem) =>
                            first<AnyObject>(data.filter((dataItem) => dataItem?.value === valueItem))?.label,
                    );
                    break;
                case autocompleteOptionList.type:
                    result.value = first<AnyObject>(data.filter((dataItem) => dataItem?.value === value))?.label;
                    break;
                default:
                    result.value = value;
            }

            return result;
        });
};

export const resetFilterFields = (filterFields: AnyObject[] = [], overwritableFilterFieldsList) => {
    return filterFields.map((filterField) => {
        const matchedOverwritableField = first<AnyObject>(
            overwritableFilterFieldsList.filter(
                (overwritableField) => overwritableField.valueFieldKey === filterField.valueFieldKey,
            ),
        );

        if (!isUndefined(matchedOverwritableField)) {
            filterField.value = matchedOverwritableField?.originalValue;
        } else {
            filterField.value = FilterHolderFields[filterField.type].defaultValue;
        }

        return filterField;
    });
};

export const createAddFilterTagDTO = (filtersTagKey, filterTagGroupName, filtersTags: AnyObject[] = []) => {
    return {
        FilterTagName: filtersTagKey,
        FilterGroup: {
            Label: filterTagGroupName,
            Filters: filtersTags.map((filterTag) => {
                return { Label: filterTag?.label, Values: [filterTag] };
            }),
        },
    };
};

export const createDeleteFilterTagDTO = (filtersTagKey, filterTagData: AnyObject = {}) => {
    return {
        FilterTagName: filtersTagKey,
        FilterGroupLabel: filterTagData?.Label,
    };
};

export const isAlreadyExistFiltersTagName = (filtersTagName = '', filtersTagsList: AnyObject[] = []) => {
    return (
        filtersTagsList.filter((filter) => filter.Label.trim().toLowerCase() === filtersTagName.trim().toLowerCase())
            .length > 0
    );
};
